module.exports = __webpack_public_path__ + "img/img07.c194752a.jpg";